import React from 'react';

import { Affix as AntAffix } from 'antd';
import { AffixProps } from 'antd/lib/affix';

export interface IAffixProps extends AffixProps {}

/**
 * Wrap Affix around another component to make it stick the viewport.'
 */
export const Affix: React.FC<IAffixProps> = (props) => <AntAffix {...props} />;
